export const onlyFootballQuery = {
  bool: {
    should: [
      {
        bool: {
          must: [
            {
              term: {
                categoryGroupName: 'FOOTBALL',
              },
            },
          ],
        },
      },
    ],
    minimum_should_match: 1,
  },
};
